module.exports = __webpack_public_path__ + "img/natice.4df17fc.svg";